import { render, staticRenderFns } from "./WechatBuybackList.vue?vue&type=template&id=724d2fe1"
import script from "./WechatBuybackList.vue?vue&type=script&lang=js"
export * from "./WechatBuybackList.vue?vue&type=script&lang=js"
import style0 from "./WechatBuybackList.vue?vue&type=style&index=0&id=724d2fe1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports